module.exports = __webpack_public_path__ + "img/MapPicsTwizzletopMountain.a69bb636.webp";